<template>
  <div id="app">
    <TopBar/>

    <div v-if="!loading && !sslCheckData" class="domainname-input">
      <div class="container">
        <div class="text-center">
          <img src="@/assets/ssl_icon.svg" alt="SSL icon" width="70" height="70">
          <h1 class="txt-description">This SSL report is FREE.<br>Enter your url below to generate your free SSL report</h1>

          <div class="div-input-domain mb-5">
            <form v-on:submit.prevent="getResults()">
              <input type="text" class="form-control" id="input-domain" placeholder="https://example.com" v-model="domainInputValue">
              <button type="submit" class="btn-submit">SSL lookup &gt;</button>
            </form>
            <p v-if="requestError" class="text-danger">{{errorMessage ? errorMessage : 'Invalid URL'}}</p>
          </div>

          <Tools/>
        </div>
      </div>
    </div>

    <div v-if="loading" class="loader-max text-center">
      <img src="@/assets/loader_max.svg" alt="loader max" width="100">
    </div>

    <div v-if="sslCheckData && !loading" class="response-wrapper mb-5">
      <div class="header-success">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 left-success">
              <a href="/"><img src="@/assets/ssl_icon.svg" alt="SSL icon" width="60" height="60"></a>
            </div>
            <div class="col-12 col-md-6 right-success">
              <form class='header-input-form' v-on:submit.prevent="getResults()">
                <input type="text" class="form-control input-new" placeholder="https://example.com" v-model="domainInputValue">
                <button type="submit" class="btn-submit">New SSL Report &gt;</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="ssl-data">
          <div class="svg-wrapper d-inline-block">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 30.7" width="32"><path d="M14.3 30.4a24.2 24.2 0 0 1-6.2-4.2 18.9 18.9 0 0 1-4.4-5.7A27.1 27.1 0 0 1 .3 7.2C3.4 6.9 5 4.6 5.8 3.5a6 6 0 0 0 1-3.1h15a5.5 5.5 0 0 0 1 3.1 7.2 7.2 0 0 0 5.5 3.3 30.3 30.3 0 0 1-3.4 13.5 23.4 23.4 0 0 1-4.4 5.8 24.5 24.5 0 0 1-6.2 4.3z" fill="#0195de"/><path d="M19.9 11l-7.5 7.5-3.7-3.7 1.8-1.9 1.9 1.9L18 9.2z" fill="#fff"/></svg>
          </div>
          <h2 class="text-center mb-4 d-inline-block"><strong class='current-url'>{{sslCheckData.more_info.force_https.last_url}}</strong>&nbsp;SSL Server Certificate</h2>
        </div>
        <div class="ssl-response mt-2 mb-4">
          <div class="main-data px-3">
            <ul class="list-unstyled">
              <li>
                <i class="d-inline-block mr-3 checkmark glyphicon glyphicon-info text-info"></i>
                <strong>Searched Item : {{sslCheckData.more_info.force_https.last_url}}</strong>
              </li>
              <li>
                <div :class="'d-inline-block mr-3 checkmark glyphicon glyphicon-level-' + sslCheckData.more_info.expire_in.valid_level"></div>
                <span v-if="sslCheckData.more_info.expire_in.valid_level === 1">The certificate will expire in {{sslCheckData.more_info.expire_in.expire_in_days}} days</span>
                <span v-else-if="sslCheckData.more_info.expire_in.valid_level === 2">The certificate will expire soon : {{sslCheckData.more_info.expire_in.expire_in_days}} left</span>
                <span v-else-if="sslCheckData.more_info.expire_in.valid_level === 3">The certificate is expired</span>
              </li>
              <li>
                <div :class="'d-inline-block mr-3 checkmark glyphicon glyphicon-level-' + sslCheckData.more_info.force_https.valid_level"></div>
                <span>{{sslCheckData.more_info.force_https.valid_level === 1 ? 'The server is forcing the use of HTTPS' : 'The server is not forcing the use of HTTPS'}}</span>
              </li>
              <li>
                <div :class="'d-inline-block mr-3 checkmark glyphicon glyphicon-level-' + sslCheckData.more_info.domain_match.valid_level"></div>
                <span>The domain is inside SAN's domain list : {{sslCheckData.more_info.domain_match.domain}}</span>
              </li>
              <li>
                <div :class="'d-inline-block mr-3 checkmark glyphicon glyphicon-level-' + sslCheckData.more_info.protocols.valid_level"></div>
                <span>Protocol version : {{sslCheckData.more_info.protocols.version}}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="accordion" id="sslDetailsAccordion">
          <div class="card">
            <div class="card-header" id="sslPartOne">
              <h5 class="mb-0 dropright">
                <button class="btn btn-link font-weight-bold pl-0 dropdown-toggle collapsed" type="button" data-toggle="collapse" data-target="#collapseSslPartOne" aria-expanded="true" aria-controls="collapseSslPartOne">Certificate Informations</button>
              </h5>
            </div>

            <div id="collapseSslPartOne" class="collapse" aria-labelledby="sslPartOne" data-parent="#sslDetailsAccordion">
              <div class="card-body pt-0">
                <p class="m-0"><strong>Common name: </strong>{{sslCheckData.cert_chain[0].commmon_name}}</p>
                <p class="m-0"><strong>SAN:</strong></p>
                <p>
                  <span v-for="(sanDomain, index) in sslCheckData.cert_chain[0].sans_domains" :key="index">{{sanDomain}}{{index != sslCheckData.cert_chain[0].sans_domains.length - 1 ? ', ' : ''}}</span>
                </p>

                <p class="m-0"><strong>Valid on:</strong> {{new Date(sslCheckData.cert_chain[0].valid_on).toLocaleDateString("en-US", dateFormatOptions)}}</p>
                <p class="m-0"><strong>Valid until:</strong> {{new Date(sslCheckData.cert_chain[0].valid_until).toLocaleDateString("en-US", dateFormatOptions)}}</p>
                <p class="m-0"><strong>Certificate status:</strong> {{sslCheckData.cert_chain[0].valid ? "Valid" : "Invalid"}}</p>
                <p class="m-0"><strong>Organization:</strong> {{sslCheckData.cert_chain[0].organization ? sslCheckData.cert_chain[0].organization : '-'}}</p>
                <p class="m-0" v-if="sslCheckData.cert_chain[0].organization_unit"><strong>Organization unit:</strong> {{sslCheckData.cert_chain[0].organization_unit ? sslCheckData.cert_chain[0].organization_unit : '-'}}</p>
                <p class="m-0"><strong>City/Locality:</strong> {{sslCheckData.cert_chain[0].location.city ? sslCheckData.cert_chain[0].location.city : '-'}}</p>
                <p class="m-0"><strong>State/Province:</strong> {{sslCheckData.cert_chain[0].location.state}}</p>
                <p class="m-0"><strong>Country:</strong> {{sslCheckData.cert_chain[0].location.country ? sslCheckData.cert_chain[0].location.country : '-'}}</p>
                <p class="m-0"><strong>Algorithm type:</strong> {{sslCheckData.cert_chain[0].signature_algorithm ? sslCheckData.cert_chain[0].signature_algorithm : '-'}}</p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="sslPartTwo">
              <h5 class="mb-0 dropright">
                <button class="btn btn-link font-weight-bold dropdown-toggle pl-0 collapsed" type="button" data-toggle="collapse" data-target="#collapseSslPartTwo" aria-expanded="false" aria-controls="collapseSslPartTwo">Is Certificate Chain Complete?</button>
              </h5>
            </div>
            <div id="collapseSslPartTwo" class="collapse" aria-labelledby="sslPartTwo" data-parent="#sslDetailsAccordion">
              <div class="card-body pt-0">
                <p v-if="certificateChainValid">All of the correct Intermediate Certificates are installed. Your SSL certificate is installed correctly and should be supported in all the major web browsers without problems.</p>
                <p v-else>Your SSL certificate is not installed correctly</p>

                <ul class="list-unstyled mt-4">
                  <li v-for="(certificate, index) in sslCheckData.cert_chain" :key="index" class="mb-3">
                    <div v-if="index - 1 > -1" class='mb-3 ml-1'>
                      <div v-if="sslCheckData.cert_chain[index - 1].valid === certificate.valid">
                        <i class="glyphicon glyphicon-link text-success"></i>
                      </div>
                      <div v-else>
                        <i class="glyphicon glyphicon-unlink text-danger"></i>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div>
                        <img v-if="certificate.valid" src="@/assets/tool_icon_green.svg" alt="" width='50' height='50' class='mr-4'>
                        <img v-else src="@/assets/cross_icon.svg" alt="" width='50' height='50' class='mr-4'>
                      </div>
                      <div>
                        <p class='m-0'><strong>Common Name:</strong> {{certificate.commmon_name ? certificate.commmon_name : '-'}}</p>
                        <p class='m-0'><strong>Organization:</strong> {{certificate.organization ? certificate.organization : '-'}}</p>
                        <p class='m-0'><strong>{{certificate.valid ? "Valid" : "Invalid"}}:</strong> {{certificate.valid ? new Date(certificate.valid_until).toLocaleDateString("en-US", dateFormatOptions) : "Expired"}}</p>
                        <p class='m-0'><strong>Issuer:</strong> {{certificate.issuer ? certificate.issuer : '-'}}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="ssl-response-error d-none"></div>

      </div>

      <div class="container mt-4">
        <h2 class="text-center mb-4 d-inline-block"><strong>Mixed Content Checkup</strong></h2>

        <div v-if="mxErrorMessage && !mxContentLoading">
          <p class="text-danger">{{mxErrorMessage}}</p>
        </div>

        <div v-if="mxCheckData === true">
          <img src="@/assets/tool_icon.svg" alt="" class="d-inline-block mr-4" width="50" height="50">
          <p class="d-inline-block">No mixed content for {{domain[1]}}</p>
        </div>
        <div v-else>
          <ul class="list-unstyled">
            <li v-for="(mixedContent, index) in mxCheckData" :key='index' class="mb-3 d-flex">
              <i :class="'d-inline-block mr-3 checkmark glyphicon glyphicon-level-' + mixedContent.level"></i>
              <span v-if="mixedContent.level === 'WARNING'">
                <strong>The following content should be served over HTTPS :</strong><br/>{{mixedContent.url}}</span>
              <span v-else>
                <strong>{{mixedContent.message}}</strong>
                <p>{{mixedContent.url}}</p>
              </span>
            </li>
          </ul>
        </div>

        <div v-if="mxContentLoading" class="text-center">
          <img src="@/assets/loader_max.svg" alt="loader max" width="80">
        </div>
      </div>
    </div>

    <Footer/>

  </div>
</template>

<script>
// dependencies
import axios from 'axios'

// components
import TopBar from './components/TopBar.vue'
import Tools from './components/Tools.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    TopBar,
    Footer,
    Tools
  },
  data () {
    return {
      loading: false,
      mxContentLoading: false,
      requestError: false,
      mxRequestError: false,
      sslCheckData: null,
      mxCheckData: null,
      errorMessage: null,
      mxErrorMessage: null,
      domainInputValue: '',
      domain: null,
      certificateChainValid: null,
      dateFormatOptions: {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
    }
  },
  methods: {
    getResults: function () {
      window.location = '/?url=' + this.domainInputValue
    },
    sslCheck: function () {
      // reset data
      this.sslCheckData = null
      this.errorMessage = null

      this.loading = true
      this.domain = extractDomainFromUrl(this.domainInputValue)
      // Get report
      if (!this.domain || !this.domain[1]) {
        this.requestError = true
        this.loading = false
        return
      } else {
        this.requestError = false
      }

      // ajax call
      axios.get('https://api.ns-lookup.io/v1/sslcheck?domain=' + this.domain[1], {timeout: 30000})
      .then((response) => {
        this.loading = false

        // Check data availability and show errors
        if(response.data.status === false && response.data.message === 'Invalid domain' || response.data.data === undefined) {
          this.requestError = true
          // Show error message if present
          if(response.data.message) {
            this.errorMessage = typeof(response.data.message) === 'string' ? response.data.message : response.data.message[0]
          } else {
            this.errorMessage = null;
          }
          return
        }

        // bind data
        this.sslCheckData = response.data.data

        // Check the validity of the certificate chain
        let isCertificateValid = false
        for (const certificate in this.sslCheckData.cert_chain) {
          if (this.sslCheckData.cert_chain.hasOwnProperty(certificate)) {
            isCertificateValid = this.sslCheckData.cert_chain[certificate].valid
          }
        }
        this.certificateChainValid = isCertificateValid ? true : false

      }, () => {
        this.errorMessage = 'An error occurred with the server, please try again later'
        this.loading = false
        this.requestError = true
      })
    },
    mxCheck: function () {
      this.mxContentLoading = true
      this.mxCheckData = null
      this.mxErrorMessage = null

      // ajax call
      axios.get('https://api.ns-lookup.io/v1/mixedcontent?url=' + this.domainInputValue, {timeout: 30000})
      .then((response) => {
        this.mxContentLoading = false

        // Check data availability and show errors
        if(response.data.data === undefined) {
          this.mxRequestError = true
          // Show error message if present
          if(response.data.message) {
            this.mxErrorMessage = typeof(response.data.message) === 'string' ? response.data.message : response.data.message[0]
          } else {
            this.mxErrorMessage = 'An error occurred, please try again later';
          }
          return
        }

        if(response.data.data.length > 0) {
          this.mxCheckData = response.data.data
        } else if(response.data.status === true) {
          this.mxCheckData = true
        }
      }, () => {
        this.mxErrorMessage = 'An error occurred, please try again later'
        this.mxContentLoading = false
        this.mxRequestError = true
      })
    }
  },
  mounted () {
    // After page load check the url if a domain is set
    let url_param = new URL(window.location.href).searchParams.get('url')
    if(!url_param) {
      // Focus the input
      document.getElementById('input-domain').focus()
      return
    }

    this.domainInputValue = url_param
    url_param = extractDomainFromUrl(url_param)

    // if there is a domain call the API
    if(url_param) {
      this.domain = url_param[1]
      this.sslCheck()
      this.mxCheck()
    }
  }
}

// Extract domain from url function
function extractDomainFromUrl(url) {
  const regex = /^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/gm
  let urlArray = regex.exec(url)
  urlArray.push(url)
  return urlArray
}
</script>
